/* GoldNX Aurum — theme JS */
(function () {
  var money = function (cents) {
    return '₹ ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /* Square, white-padded CDN image — matches the rest of the theme, never crops */
  function squareUrl(url, size) {
    if (!url) return url;
    var s = size || 200;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + s + '&height=' + s + '&pad_color=ffffff';
  }

  /* Mobile menu */
  var mdrawer = document.getElementById('MobileDrawer');
  document.querySelectorAll('[data-open-menu]').forEach(function (b) {
    b.addEventListener('click', function () { mdrawer && mdrawer.classList.add('open'); });
  });
  document.querySelectorAll('[data-close-menu]').forEach(function (b) {
    b.addEventListener('click', function () { mdrawer && mdrawer.classList.remove('open'); });
  });

  /* Tabs */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var btns = wrap.querySelectorAll('.tabs button');
    var panels = wrap.querySelectorAll('.tabpanel');
    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('on'); });
        panels.forEach(function (p) { p.classList.remove('on'); });
        btn.classList.add('on');
        if (panels[i]) panels[i].classList.add('on');
      });
    });
  });

  /* Hero slideshow */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('.hero__track');
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dots button');
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
    }
    function auto() { timer = setInterval(function () { go(i + 1); }, 5000); }
    hero.querySelectorAll('.hero__arrow--prev').forEach(function (b) { b.addEventListener('click', function () { clearInterval(timer); go(i - 1); auto(); }); });
    hero.querySelectorAll('.hero__arrow--next').forEach(function (b) { b.addEventListener('click', function () { clearInterval(timer); go(i + 1); auto(); }); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { clearInterval(timer); go(j); auto(); }); });
    auto();
  });

  /* Wishlist */
  var WKEY = 'goldnx_wishlist';
  function wishlist() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function renderWishCount() {
    var n = wishlist().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = n; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wish');
    var list = wishlist();
    var idx = list.indexOf(id);
    if (idx > -1) list.splice(idx, 1); else list.push(id);
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (err) {}
    b.classList.toggle('on', idx === -1);
    renderWishCount();
  });
  document.querySelectorAll('[data-wish]').forEach(function (b) {
    if (wishlist().indexOf(b.getAttribute('data-wish')) > -1) b.classList.add('on');
  });
  renderWishCount();

  /* Cart drawer */
  var cdrawer = document.getElementById('CartDrawer');
  function openCart() { cdrawer && cdrawer.classList.add('open'); }
  document.querySelectorAll('[data-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(openCart); });
  });
  document.querySelectorAll('[data-close-cart]').forEach(function (b) {
    b.addEventListener('click', function () { cdrawer.classList.remove('open'); });
  });

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      var items = document.getElementById('CartDrawerItems');
      var foot = document.getElementById('CartDrawerFoot');
      if (!items) return cart;
      if (!cart.items.length) {
        items.innerHTML = '<div class="cdrawer__empty"><p>Your bag is empty.</p><a class="btn btn--gold" href="/collections/all">Shop bestsellers</a></div>';
        if (foot) foot.style.display = 'none';
        return cart;
      }
      if (foot) foot.style.display = '';
      items.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + squareUrl(it.image, 200) + '" alt="">' : '<div style="width:72px;height:72px;background:#f1e9d8"></div>';
        return '<div class="citem" data-key="' + it.key + '">' + img +
          '<div><div class="citem__title">' + it.product_title + '</div>' +
          (it.variant_title ? '<div style="font-size:12px;color:#8a8378">' + it.variant_title + '</div>' : '') +
          '<div class="citem__qty"><button data-cart-qty="-1">−</button><span>' + it.quantity + '</span><button data-cart-qty="1">+</button></div></div>' +
          '<div style="text-align:right"><div>' + money(it.final_line_price) + '</div><button class="citem__rm" data-cart-remove>Remove</button></div></div>';
      }).join('');
      var totalEl = document.getElementById('CartDrawerTotal');
      if (totalEl) totalEl.textContent = money(cart.total_price);
      var ship = document.getElementById('CartDrawerShip');
      if (ship) {
        var threshold = parseFloat(ship.getAttribute('data-threshold') || '0') * 100;
        if (threshold > 0) {
          ship.textContent = cart.total_price >= threshold
            ? 'You have unlocked FREE shipping.'
            : 'Add ' + money(threshold - cart.total_price) + ' more for FREE shipping.';
        }
      }
      return cart;
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(refreshCart);
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (q) {
      var row = q.closest('.citem');
      var cur = parseInt(row.querySelector('.citem__qty span').textContent, 10);
      changeLine(row.getAttribute('data-key'), Math.max(0, cur + parseInt(q.getAttribute('data-cart-qty'), 10)));
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) changeLine(rm.closest('.citem').getAttribute('data-key'), 0);
  });

  /* Toast notification */
  function showToast(msg) {
    var t = document.getElementById('gnx-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'gnx-toast';
      t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#1a1a1a;color:#fff;padding:13px 28px;border-radius:999px;font-size:13px;letter-spacing:.04em;z-index:9999;opacity:0;transition:opacity .3s;pointer-events:none;white-space:nowrap;box-shadow:0 4px 20px rgba(0,0,0,.3)';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.opacity = '1';
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.style.opacity = '0'; }, 2500);
  }

  /* AJAX add to cart — silent, shows toast, keeps user on page */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var old = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { showToast('Added to bag! Tap 🛍️ to checkout'); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = old; } });
  });

  /* PDP quantity */
  document.querySelectorAll('[data-qty]').forEach(function (w) {
    var input = w.querySelector('input');
    w.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-step'), 10));
      });
    });
  });

  /* PDP variant select */
  document.querySelectorAll('[data-variants]').forEach(function (wrap) {
    var data = JSON.parse(wrap.querySelector('script[type="application/json"]').textContent);
    var selects = wrap.querySelectorAll('select[data-opt]');
    var idInput = document.querySelector('form[data-ajax-cart] input[name="id"]');
    var priceEl = document.querySelector('[data-prod-price]');
    var wasEl = document.querySelector('[data-prod-was]');
    var addBtn = document.querySelector('form[data-ajax-cart] [type="submit"]');
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(selects, function (x) { return x.value; });
        var v = data.find(function (variant) {
          return chosen.every(function (val, i) { return variant.options[i] === val; });
        });
        if (v && idInput) {
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (wasEl) wasEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
          if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to bag' : 'Sold out'; }
        }
      });
    });
  });

  /* Product gallery thumbs */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.prod__main img');
    g.querySelectorAll('.prod__thumbs button').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('.prod__thumbs button').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-src'); }
      });
    });
  });

  refreshCart();
})();
